import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useShipFromContext } from '../../contexts/ship-from-context';
import ShipFromAddress from '../ship-from-address';
import ResidentialCheckbox from './residential-checkbox';
import messages from '../messages';
import style from '../style.module.less';
import PropTypes from 'prop-types';

const OriginAddress = ({ shouldHideAddressHeader = false }) => {
  const {
    shipFrom,
    updateShipFrom,
    validationErrors,
    returnAddressSameAsShipFrom,
    showValidation,
    shouldHideTimezone,
    trackInputChange,
    trackInputClick,
  } = useShipFromContext();

  const onChange = useCallback(
    (address) => {
      const updatePayload = {
        originAddress: address,
      };
      if (returnAddressSameAsShipFrom) {
        updatePayload.returnAddress = address;
      }

      updateShipFrom(updatePayload);
    },
    [updateShipFrom, returnAddressSameAsShipFrom],
  );

  const onResidentialIndicatorChange = useCallback(
    (residentialIndicator) => {
      onChange({
        ...shipFrom.originAddress,
        residentialIndicator,
      });
      trackInputChange('residentialIndicator', residentialIndicator);
    },
    [onChange, shipFrom.originAddress, trackInputChange],
  );

  return (
    <div>
      {!shouldHideAddressHeader && (
        <h4 className={style['address-header']}>
          <FormattedMessage {...messages.originAddressHeader} />
        </h4>
      )}
      <ResidentialCheckbox onChange={onResidentialIndicatorChange} residentialIndicator={shipFrom.originAddress.residentialIndicator} />
      <ShipFromAddress
        address={shipFrom.originAddress}
        errors={validationErrors?.originAddress}
        onChange={onChange}
        shouldHideTimezone={shouldHideTimezone}
        showValidation={showValidation}
        trackInputChange={trackInputChange}
        trackInputClick={trackInputClick}
      />
    </div>
  );
};

OriginAddress.propTypes = {
  shouldHideAddressHeader: PropTypes.bool,
};

export default OriginAddress;
